/*
 * Cyber Monday 2026 — timer de la barra (sections/vk-cyber-timer.liquid) y sellos "CYBER" (sin %)
 * (snippets/vk-cyber-badge.liquid). El estado se decide con la hora del cliente:
 *   antes del inicio → barra "antes" + cuenta al inicio, sellos ocultos
 *   durante          → barra "durante" + cuenta al fin + botón, sellos visibles
 *   después del fin  → barra y sellos ocultos
 * ?cyber_preview=1 fuerza "durante" (queda guardado en la pestaña); ?cyber_preview=0 lo apaga.
 */
(function () {
  'use strict';

  var DEFAULT_START = '2026-10-09T00:00:00-03:00'; // campaña "Extendimos el Cyber" (vie 9 → lun 12)
  var DEFAULT_END = '2026-10-12T23:59:59-03:00';
  var KEY = 'vkCyberPreview';
  var MAX_PCT = 27; // por defecto; el timer lo pisa con data-max-pct (setting "Descuento máximo real")

  function previewOn() {
    var param = null;
    try { param = new URLSearchParams(window.location.search).get('cyber_preview'); } catch (e) {}
    try {
      if (param === '1') sessionStorage.setItem(KEY, '1');
      if (param === '0') sessionStorage.removeItem(KEY);
      return param === '1' || (param !== '0' && sessionStorage.getItem(KEY) === '1');
    } catch (e) {
      return param === '1';
    }
  }

  var timer = document.querySelector('[data-vk-cyber-timer]');
  if (timer && parseFloat(timer.dataset.maxPct) > 0) MAX_PCT = parseFloat(timer.dataset.maxPct);
  var start = Date.parse((timer && timer.dataset.start) || DEFAULT_START);
  var end = Date.parse((timer && timer.dataset.end) || DEFAULT_END);
  var preview = previewOn();

  function phase(now) {
    if (preview) return 'during';
    if (now < start) return 'before';
    if (now <= end) return 'during';
    return 'after';
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function format(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  /* Sellos */
  function updateBadges(p) {
    var badges = document.querySelectorAll('[data-vk-cyber-badge]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var price = parseFloat(b.dataset.price);
      var compare = parseFloat(b.dataset.compare);
      // 4-oct-2026: hacia abajo (27,9% → −27%), nunca mostrar más descuento que el real; +1e-9 evita errores de coma flotante
      var pct = compare > 0 && price > 0 ? Math.floor((1 - price / compare) * 100 + 1e-9) : 0;
      // 4-oct-2026 (Matías): el sello dice solo "CYBER", sin porcentaje (compare_at inflados daban hasta −99%)
      if (p === 'during' && (pct > 0 || preview)) {
        b.textContent = 'CYBER';
        b.hidden = false;
      } else {
        b.hidden = true;
      }
    }
    // Sellos "-XX%" contra compare_at (todos los productos): durante el Cyber se ocultan si pasan del máximo real (27%),
    // para que nada en pantalla contradiga "hasta −27%". Fuera del Cyber se ven como siempre.
    var caps = document.querySelectorAll('[data-vk-cyber-cap]');
    for (var j = 0; j < caps.length; j++) {
      var c = caps[j];
      var v = parseFloat(c.getAttribute('data-vk-cyber-cap'));
      c.hidden = p === 'during' && v > MAX_PCT;
    }
  }

  /* Timer */
  var els = timer ? {
    before: timer.querySelectorAll('[data-vkct-before],[data-vkct-before-short]'),
    during: timer.querySelectorAll('[data-vkct-during],[data-vkct-during-short]'),
    clock: timer.querySelector('[data-vkct-clock]'),
    btn: timer.querySelector('[data-vkct-btn]')
  } : null;

  function setAll(list, hidden) { for (var i = 0; i < list.length; i++) list[i].hidden = hidden; }

  var lastPhase = null;
  function tick() {
    var now = Date.now();
    var p = phase(now);
    if (p !== lastPhase) {
      updateBadges(p);
      if (els) {
        // show_before = false (setting): la barra no aparece antes del inicio, solo desde start
        timer.hidden = p === 'after' || (p === 'before' && timer.getAttribute('data-show-before') === 'false');
        setAll(els.before, p !== 'before');
        setAll(els.during, p !== 'during');
        if (els.btn) els.btn.hidden = p !== 'during';
      }
      lastPhase = p;
    }
    if (els && p !== 'after') {
      var target = p === 'before' ? start : end;
      if (preview && now > end) target = now + 86400000; // vista previa después del fin: cuenta de muestra
      els.clock.textContent = format(target - now);
    }
    if (p === 'after') return; // nada más que actualizar
    window.setTimeout(tick, 1000 - (now % 1000));
  }

  /* Productos que se cargan después (filtros, "cargar más", quick view): re-aplica los sellos. */
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (records) {
      var added = false;
      for (var r = 0; r < records.length && !added; r++) {
        var nodes = records[r].addedNodes;
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (node.nodeType === 1 && (node.matches('[data-vk-cyber-badge],[data-vk-cyber-cap]') || node.querySelector('[data-vk-cyber-badge],[data-vk-cyber-cap]'))) { added = true; break; }
        }
      }
      if (!added || pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; updateBadges(phase(Date.now())); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  tick();
})();
